var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-white text-opacity-75 font-thin opacity-70 leading-tight my-8  text-left",class:[
    'xl:text-base ',
    'lg:text-sm',
    'md:text-sm ',
    'sm:text-sm',
    'text-sm '
  ]},[_vm._v(" "+_vm._s(_vm.title)+" is suitable for "),_c('span',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.tags.map(function (t) { return t.title; }).join(', ')))])])}
var staticRenderFns = []

export { render, staticRenderFns }